function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;}\n\t.st1{fill:none;stroke:#000000;stroke-width:24;stroke-linecap:round;stroke-linejoin:round;}\n");

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "st0",
  width: 256,
  height: 256
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M152,208v-48c0-4.4-3.6-8-8-8h-32c-4.4,0-8,3.6-8,8v48c0,4.4-3.6,8-8,8l-48,0c-4.4,0-8-3.6-8-8c0,0,0,0,0,0 v-92.5c0-2.3,1-4.4,2.6-5.9l80-72.7c3.1-2.8,7.7-2.8,10.8,0l80,72.7c1.7,1.5,2.6,3.7,2.6,5.9V208c0,4.4-3.6,8-8,8c0,0,0,0,0,0l-48,0 C155.6,216,152,212.4,152,208z"
});

function SvgHouseBold(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raw",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256 256",
    style: {
      enableBackground: "new 0 0 256 256"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBold);
export default __webpack_public_path__ + "static/media/house-bold.ceed40a4.svg";
export { ForwardRef as ReactComponent };